/**
 * Tv Episode Row to VOD section
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.01.2015-19:42
 */

lmApp.controller('LmTvEpisodeRowController', ['$rootScope', '$scope', '$interval', '$timeout', '$compile', 'AssetService', 'MetadataService',
  function ($rootScope, $scope, $interval, $timeout, $compile, AssetService, MetadataService) {
    $scope.version = jwplayer && jwplayer.version.split('+')[0] || '';

    if (!$scope.asset || $scope.isHeader) {
      return;
    }

    $scope.actionShown = false;

    $scope.parseTvEpisodeRow = function (asset) {

      $scope.assetData = angular.copy(asset);
      $scope.prepareTvEpisodeRowStatus();

      if (!$scope.posterData) $scope.posterData = {};

      var needUpdate = $scope.assetData._status.streams.filter(function (stream) {

        return stream._is_transcoding || !stream.is_deployed;
      });

      if ($scope.updateIntreval && !needUpdate.length && $scope.assetData._status.poster) {
        $interval.cancel($scope.updateIntreval);
      } else if (needUpdate.length || !$scope.assetData._status.poster) {

        if ($scope.updateIntreval) {
          $interval.cancel($scope.updateIntreval);
        }

        $scope.updateIntreval = $interval(function () {

          $rootScope.$broadcast($rootScope.EVENTS.UPDATE_VOD_COLLECTION, {
            id: $scope.assetData.id,
            isSilentUpdate: true,
            isEpisode: true,
            season: {}
          });
        }, 30 * 1000);
      }

      AssetService.GetPoster(asset)
        .then(function (url) {
          $scope.posterData.t = _.get(_.find(asset.resources, {type: 'picture'}), 'uptime_time') || Date.now();
          $scope.posterData.url = url;
        });
    };

    $scope.prepareTvEpisodeRowStatus = function () {
      $scope.assetData._status = {
        streams: $scope.assetData.resources.filter(function (resource) {
          return resource.type === 'stream';
        }).map(function (resource) {
          if (resource.stream_type.indexOf('youtube') !== -1) {
            $scope.assetData._has_youtube = true;
            resource.stream_type = 'youtube';
            resource._stream_sub_type = 'y';
          }

          resource._stream_type = MetadataService._STREAM_TYPES_ATTRS[resource.stream_type];

          if (resource.category) resource._stream_sub_type = resource.category[0];

          resource._is_transcoding = !!resource.noisypeak_job && (resource.noisypeak_job_error || !resource.noisypeak_job_is_complete);

          if (resource._is_transcoding) {
            resource._transcoding = resource.noisypeak_job_error ? resource.noisypeak_job_error : resource.noisypeak_job_progress.toString() + '% transcoding';
          }

          return resource;
        }),
        poster: _.find($scope.assetData.resources, {category: 'poster_blueprint'}) && _.find($scope.assetData.resources, {category: 'poster_blueprint'}).is_deployed,
        rental: MetadataService.Rental.Check($scope.assetData)
      };
    };

    $scope.streamData = {
      isStreamReady: false,
      status: '',
      isStreamAvailable: function (asset) {

        var resources = asset.resources && asset.resources.filter(function (resource) {
            return resource.type === 'stream' && resource.stream_type === 'hls';
          });

        var isDeployedRes = resources && resources.filter(function (resource) {
            return resource.is_deployed;
          });

        this.status = '';

        switch (true) {
          case !resources || !resources.length:
            this.status = 'No stream data in asset';
            break;

          case !isDeployedRes || !isDeployedRes.length:
            this.status = 'Stream is not deployed yet';
            break;

          default :
            this.status = '';
            break;
        }

        return asset.resources && isDeployedRes && isDeployedRes.length > 0;
      },

      closeStream: function (event) {
        var contentTr = angular.element('#jw_player');

        if (contentTr.length) {
          $rootScope.watchingAssetId = '';
          contentTr.remove();
        }
      },

      openStream: function (asset, event) {
        if (event && event.stopPropagation) event.stopPropagation();
        if (event && event.preventDefault) event.preventDefault();
        if (asset.id === $rootScope.watchingAssetId) return;

        if (!this.isStreamAvailable(asset)) return;

        this.closeStream();

        $scope.prepareTvEpisodeRowStatus();

        if (asset._status && asset._status.streams.length) {

          AssetService.GetStream(asset, asset._status.streams[0].stream_type, asset._status.streams[0].category)
            .then(function (url) {
              $rootScope.watchingAssetId = asset.id;
              var contentTr = angular.element('<lm-jwplayer url="' + url + '"></lm-jwplayer>');
              contentTr.insertAfter(event.currentTarget.parentNode);
              $compile(contentTr)($scope);
            }.bind(this));
        }
      },

      changeStream: function (index) {
        if ($scope.assetData._status.streams && $scope.assetData._status.streams[index]) {

          AssetService.GetStream($scope.assetData, $scope.assetData._status.streams[index.stream_type], $scope.assetData._status.streams[index].category)
            .then(function (url) {
              $scope.url = url;
            }, function (reason) {
              $scope.playbackError = reason;
            });
        }
      }
    };

    $scope.deleteAsset = function (event) {
      if (event && event.stopPropagation) event.stopPropagation();
      if (event && event.preventDefault) event.preventDefault();

      $scope.deleteFn(event);
    };

    $scope.parseTvEpisodeRow($scope.asset);
    $scope.prepareTvEpisodeRowStatus();

    $scope.assetWatcher = $scope.$watchCollection('asset', function (newValue) {
      if (!newValue) return;

      $scope.parseTvEpisodeRow(newValue);
    });

    $scope.$on('$destroy', function () {
      $scope.assetWatcher();
      $interval.cancel($scope.updateIntreval);
    });

  }]);

lmApp.
  directive('lmTvEpisodeRow', ['$compile', 'AssetService', function ($compile, AssetService) {
    return {
      restrict: 'E',
      scope: {
        asset: '=',
        season: '=',
        editFn: '&',
        deleteFn: '&',
        isHeader: '='
      },
      replace: true,
      controller: 'LmTvEpisodeRowController',
      templateUrl: 'lm-table-rows/tv-episode-row/tv-episode-row.tpl.html'
    };
  }]);
